import { ContentType } from 'types/App';

export const CONTENT_TYPE_LIST: ContentType[] = ['video', 'link', 'image', 'pdf', 'none_data'];
